import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { alignCenter as $f62d864046160412$export$f4a51ff076cc9a09, constrainValue as $f62d864046160412$export$4f5203c0d889109e, isInvalid as $f62d864046160412$export$eac50920cf2fd59a, previousAvailableDate as $f62d864046160412$export$a1d3911297b952d7 } from "./utils.module.js";
import { useCalendarState as $131cf43a05231e1e$export$6d095e787d2b5e1f } from "./useCalendarState.module.js";
import { toCalendarDate as $d0gbl$toCalendarDate, maxDate as $d0gbl$maxDate, minDate as $d0gbl$minDate, isEqualDay as $d0gbl$isEqualDay, toCalendar as $d0gbl$toCalendar, GregorianCalendar as $d0gbl$GregorianCalendar } from "@internationalized/date";
import { useControlledState as $d0gbl$useControlledState } from "@react-stately/utils";
import { useState as $d0gbl$useState, useRef as $d0gbl$useRef, useMemo as $d0gbl$useMemo } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $9a36b6ba2fb1a7c5$export$9a987164d97ecc90(props) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    onChange = props.onChange,
    createCalendar = props.createCalendar,
    locale = props.locale,
    _props$visibleDuratio = props.visibleDuration,
    visibleDuration = _props$visibleDuratio === void 0 ? {
      months: 1
    } : _props$visibleDuratio,
    minValue = props.minValue,
    maxValue = props.maxValue,
    calendarProps = _objectWithoutProperties(props, ["value", "defaultValue", "onChange", "createCalendar", "locale", "visibleDuration", "minValue", "maxValue"]);
  var _ref = (0, $d0gbl$useControlledState)(valueProp, defaultValue || null, onChange),
    _ref2 = _slicedToArray(_ref, 2),
    value = _ref2[0],
    setValue = _ref2[1];
  var _ref3 = (0, $d0gbl$useState)(null),
    _ref4 = _slicedToArray(_ref3, 2),
    anchorDate = _ref4[0],
    setAnchorDateState = _ref4[1];
  var alignment = 'center';
  if (value && value.start && value.end) {
    var start = (0, $f62d864046160412$export$f4a51ff076cc9a09)((0, $d0gbl$toCalendarDate)(value.start), visibleDuration, locale, minValue, maxValue);
    var end = start.add(visibleDuration).subtract({
      days: 1
    });
    if (value.end.compare(end) > 0) alignment = 'start';
  }
  // Available range must be stored in a ref so we have access to the updated version immediately in `isInvalid`.
  var availableRangeRef = (0, $d0gbl$useRef)(null);
  var _ref5 = (0, $d0gbl$useState)(null),
    _ref6 = _slicedToArray(_ref5, 2),
    availableRange = _ref6[0],
    setAvailableRange = _ref6[1];
  var min = (0, $d0gbl$useMemo)(function () {
    return (0, $d0gbl$maxDate)(minValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.start);
  }, [minValue, availableRange]);
  var max = (0, $d0gbl$useMemo)(function () {
    return (0, $d0gbl$minDate)(maxValue, availableRange === null || availableRange === void 0 ? void 0 : availableRange.end);
  }, [maxValue, availableRange]);
  var calendar = (0, $131cf43a05231e1e$export$6d095e787d2b5e1f)(_objectSpread({}, calendarProps, {
    value: value && value.start,
    createCalendar: createCalendar,
    locale: locale,
    visibleDuration: visibleDuration,
    minValue: min,
    maxValue: max,
    selectionAlignment: alignment
  }));
  var updateAvailableRange = function updateAvailableRange(date) {
    if (date && props.isDateUnavailable && !props.allowsNonContiguousRanges) {
      var nextAvailableStartDate = $9a36b6ba2fb1a7c5$var$nextUnavailableDate(date, calendar, -1);
      var nextAvailableEndDate = $9a36b6ba2fb1a7c5$var$nextUnavailableDate(date, calendar, 1);
      availableRangeRef.current = {
        start: nextAvailableStartDate,
        end: nextAvailableEndDate
      };
      setAvailableRange(availableRangeRef.current);
    } else {
      availableRangeRef.current = null;
      setAvailableRange(null);
    }
  };
  // If the visible range changes, we need to update the available range.
  var _ref7 = (0, $d0gbl$useState)(calendar.visibleRange),
    _ref8 = _slicedToArray(_ref7, 2),
    lastVisibleRange = _ref8[0],
    setLastVisibleRange = _ref8[1];
  if (!(0, $d0gbl$isEqualDay)(calendar.visibleRange.start, lastVisibleRange.start) || !(0, $d0gbl$isEqualDay)(calendar.visibleRange.end, lastVisibleRange.end)) {
    updateAvailableRange(anchorDate);
    setLastVisibleRange(calendar.visibleRange);
  }
  var setAnchorDate = function setAnchorDate(date) {
    if (date) {
      setAnchorDateState(date);
      updateAvailableRange(date);
    } else {
      setAnchorDateState(null);
      updateAvailableRange(null);
    }
  };
  var highlightedRange = anchorDate ? $9a36b6ba2fb1a7c5$var$makeRange(anchorDate, calendar.focusedDate) : value && $9a36b6ba2fb1a7c5$var$makeRange(value.start, value.end);
  var selectDate = function selectDate(date) {
    if (props.isReadOnly) return;
    var constrainedDate = (0, $f62d864046160412$export$4f5203c0d889109e)(date, min, max);
    var previousAvailableConstrainedDate = (0, $f62d864046160412$export$a1d3911297b952d7)(constrainedDate, calendar.visibleRange.start, props.isDateUnavailable);
    if (!previousAvailableConstrainedDate) return;
    if (!anchorDate) setAnchorDate(previousAvailableConstrainedDate);else {
      var range = $9a36b6ba2fb1a7c5$var$makeRange(anchorDate, previousAvailableConstrainedDate);
      if (range) setValue({
        start: $9a36b6ba2fb1a7c5$var$convertValue(range.start, value === null || value === void 0 ? void 0 : value.start),
        end: $9a36b6ba2fb1a7c5$var$convertValue(range.end, value === null || value === void 0 ? void 0 : value.end)
      });
      setAnchorDate(null);
    }
  };
  var _ref9 = (0, $d0gbl$useState)(false),
    _ref10 = _slicedToArray(_ref9, 2),
    isDragging = _ref10[0],
    setDragging = _ref10[1];
  var isDateUnavailable = props.isDateUnavailable;
  var isInvalidSelection = (0, $d0gbl$useMemo)(function () {
    if (!value || anchorDate) return false;
    if (isDateUnavailable && (isDateUnavailable(value.start) || isDateUnavailable(value.end))) return true;
    return (0, $f62d864046160412$export$eac50920cf2fd59a)(value.start, minValue, maxValue) || (0, $f62d864046160412$export$eac50920cf2fd59a)(value.end, minValue, maxValue);
  }, [isDateUnavailable, value, anchorDate, minValue, maxValue]);
  var isValueInvalid = props.isInvalid || props.validationState === 'invalid' || isInvalidSelection;
  var validationState = isValueInvalid ? 'invalid' : null;
  return _objectSpread({}, calendar, {
    value: value,
    setValue: setValue,
    anchorDate: anchorDate,
    setAnchorDate: setAnchorDate,
    highlightedRange: highlightedRange,
    validationState: validationState,
    isValueInvalid: isValueInvalid,
    selectFocusedDate: function selectFocusedDate() {
      selectDate(calendar.focusedDate);
    },
    selectDate: selectDate,
    highlightDate: function highlightDate(date) {
      if (anchorDate) calendar.setFocusedDate(date);
    },
    isSelected: function isSelected(date) {
      return Boolean(highlightedRange && date.compare(highlightedRange.start) >= 0 && date.compare(highlightedRange.end) <= 0 && !calendar.isCellDisabled(date) && !calendar.isCellUnavailable(date));
    },
    isInvalid: function isInvalid(date) {
      var _availableRangeRef_current, _availableRangeRef_current1;
      return calendar.isInvalid(date) || (0, $f62d864046160412$export$eac50920cf2fd59a)(date, (_availableRangeRef_current = availableRangeRef.current) === null || _availableRangeRef_current === void 0 ? void 0 : _availableRangeRef_current.start, (_availableRangeRef_current1 = availableRangeRef.current) === null || _availableRangeRef_current1 === void 0 ? void 0 : _availableRangeRef_current1.end);
    },
    isDragging: isDragging,
    setDragging: setDragging
  });
}
function $9a36b6ba2fb1a7c5$var$makeRange(start, end) {
  if (!start || !end) return null;
  if (end.compare(start) < 0) {
    start = end;
    end = start;
  }
  return {
    start: (0, $d0gbl$toCalendarDate)(start),
    end: (0, $d0gbl$toCalendarDate)(end)
  };
}
function $9a36b6ba2fb1a7c5$var$convertValue(newValue, oldValue) {
  // The display calendar should not have any effect on the emitted value.
  // Emit dates in the same calendar as the original value, if any, otherwise gregorian.
  newValue = (0, $d0gbl$toCalendar)(newValue, (oldValue === null || oldValue === void 0 ? void 0 : oldValue.calendar) || new (0, $d0gbl$GregorianCalendar)());
  // Preserve time if the input value had one.
  if (oldValue && 'hour' in oldValue) return oldValue.set(newValue);
  return newValue;
}
function $9a36b6ba2fb1a7c5$var$nextUnavailableDate(anchorDate, state, dir) {
  var nextDate = anchorDate.add({
    days: dir
  });
  while ((dir < 0 ? nextDate.compare(state.visibleRange.start) >= 0 : nextDate.compare(state.visibleRange.end) <= 0) && !state.isCellUnavailable(nextDate)) nextDate = nextDate.add({
    days: dir
  });
  if (state.isCellUnavailable(nextDate)) return nextDate.add({
    days: -dir
  });
}
export { $9a36b6ba2fb1a7c5$export$9a987164d97ecc90 as useRangeCalendarState };